"use client";

export function WalletSkeleton() {
  return (
    <div className="animate-pulse space-y-6" data-testid="wallet-skeleton">
      <div className="h-44 w-full rounded-2xl bg-gray-200" />
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {[1, 2].map((i) => (
          <div key={i} className="space-y-3">
            <div className="h-5 w-40 rounded bg-gray-200" />
            {[1, 2, 3].map((j) => (
              <div key={j} className="h-14 w-full rounded-lg bg-gray-200" />
            ))}
          </div>
        ))}
      </div>
      <div className="flex justify-center">
        <div className="h-12 w-64 rounded-full bg-gray-200" />
      </div>
      <div className="space-y-3">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="h-12 w-full rounded-lg bg-gray-200" />
        ))}
      </div>
    </div>
  );
}
